(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ── HASH SCROLL ────────────────────────────── */
  const _url = new URL(window.location.href);
  if (_url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(_url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  /* ── QUICK VIEW MODAL LOGIC ─────────────────── */
  (function() {
    const overlay  = document.getElementById('maisonModal');
    const closeBtn = document.getElementById('maisonModalClose');
    const imgEl    = document.getElementById('maisonModalImg');
    const nameEl   = document.getElementById('maisonModalName');
    const priceEl  = document.getElementById('maisonModalPrice');
    const descEl   = document.getElementById('maisonModalDesc');
    const linkEl   = document.getElementById('maisonModalLink');

    function openModal(btn) {
      imgEl.src         = btn.dataset.productImage || '';
      imgEl.alt         = btn.dataset.productTitle || '';
      nameEl.textContent  = btn.dataset.productTitle || '';
      priceEl.textContent = btn.dataset.productPrice || '';
      descEl.textContent  = btn.dataset.productDesc  || '';
      linkEl.href         = btn.dataset.productUrl   || '#';
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Delegate clicks for Quick View buttons (works with infinite scroll)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.maison-quick-view');
      if (btn) { e.preventDefault(); openModal(btn); }
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

    /* ── SCROLL REVEAL ──────────────────────────── */
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    function observeCards() {
      document.querySelectorAll('.maison-card-reveal').forEach(card => {
        // Only observe cards that haven't already animated via CSS
        if (getComputedStyle(card).animationName === 'none') {
          card.style.opacity = '0';
          card.style.transform = 'translateY(18px)';
          card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
          observer.observe(card);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', observeCards);

    // Re-run when infinite scroll loads new products
    const grid = document.querySelector('.product-grid-container');
    if (grid) {
      new MutationObserver(observeCards).observe(grid, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
